// External URL — redirect users to AsiaCommerce's own registration page
export const REGISTER_URL = "https://app.asiacommerce.net/register";
